import { Skeleton } from '@/components/shadcn/skeleton'

export const BarChartSkeleton = () => {
  return (
    <div className="flex h-[300px] w-[300px] items-end justify-center gap-2 p-4">
      <Skeleton className="h-[120px] w-8" />
      <Skeleton className="h-[180px] w-8" />
      <Skeleton className="h-[90px] w-8" />
      <Skeleton className="h-[200px] w-8" />
      <Skeleton className="h-[150px] w-8" />
      <Skeleton className="h-[110px] w-8" />
      <Skeleton className="h-[170px] w-8" />
      <Skeleton className="h-[140px] w-8" />
    </div>
  )
}
